import { useEffect, useState } from 'react';

/** Viewports at or below this width use the compact (phone / small tablet) shell. */
export const COMPACT_LAYOUT_MAX_PX = 900;

export const COMPACT_LAYOUT_MEDIA_QUERY = `(max-width: ${COMPACT_LAYOUT_MAX_PX}px)`;

/**
 * True when the viewport is narrow enough for the mobile shell
 * (bottom nav, drawer sidebar, inspector sheet).
 */
export function useCompactLayout(): boolean {
  const [isCompact, setIsCompact] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia(COMPACT_LAYOUT_MEDIA_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return;
    }

    const media = window.matchMedia(COMPACT_LAYOUT_MEDIA_QUERY);
    const onChange = (event: MediaQueryListEvent) => {
      setIsCompact(event.matches);
    };

    setIsCompact(media.matches);

    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    }

    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, []);

  return isCompact;
}
